import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@tuniao/tn-icon/dist/base64/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
Vue.use(Vant);
Vue.use(VueI18n);
Vue.use(VueCookies)
const langAliasMap = {
	zh: 'de',
	en: 'pt',
	ja: 'fr',
	kr: 'ga',
};
const savedLang = localStorage.getItem("lang");
const normalizedLang = langAliasMap[savedLang] || savedLang || "de";
if (savedLang !== normalizedLang) {
	localStorage.setItem("lang", normalizedLang);
}
const i18n = new VueI18n({
	globalInjection: true,
	locale: normalizedLang,
	messages: {
		'de': require('./assets/languages/de.json'),
		'pt': require('./assets/languages/pt.json'),
		'fr': require('./assets/languages/fr.json'),
		'ga': require('./assets/languages/ga.json')
	}
});
window.$i18n = i18n;
new Vue({
	store,
	router,
	i18n,
	render: h => h(App),
}).$mount('#app')
